import { Outlet, useLocation, Navigate } from 'react-router-dom'
import ProgressBar from 'components/common/ProgressBar/ProgressBar'

const ClaimApplication = () => {
  const { pathname, state } = useLocation()
  const { claimsPersonConcerned, claimsClientInfo, singleContract, contract, claim } = state || {}
  let step = state?.step || 0
  const stepNumber = 5 - ( claimsPersonConcerned === false || claimsClientInfo === false ? 1 : 0 ) - ( claimsClientInfo === false ? 1 : 0 ) - ( singleContract ? 1 : 0 )
  if (step > 0 && claimsClientInfo === false) step--
  if (step > 0 && (claimsPersonConcerned === false  || claimsClientInfo === false)) step--
  if (step > 0 && singleContract) step--

  return (
    <>
      <ProgressBar stepNumber={stepNumber} step={step} type="dashed" />
      {pathname !== '/claims/new' && ((!state?.step && state?.step !== 0) || ((!contract && state.step > 0) || (!claim && state.step > 2)))
        ? <Navigate to={'/claims/new'} replace /> // console.log({pathname, step: state?.step, contract, claim}) //
        : <Outlet />
      }
    </>
  )
}

export default ClaimApplication
